export const routePaths = {
  root: "/",
  auth: "/auth",
  authChildren: {
    signIn: "/sign-in",
    signInAbsolute: "/auth/sign-in",
    signUp: "/sign-up",
    signUpAbsolute: "/auth/sign-up",
    forgottenPassword: "/forgot-password",
    forgottenPasswordAbsolute: "/auth/forgot-password",
    resetPassword: "/reset-password",
    resetPasswordAbsolute: "/auth/reset-password",
  },
  profile: "/profile",
  profileChildren: {
    home: "/home",
    homeAbsolute: "/profile/home",
    users: "/users",
    usersAbsolute: "/profile/users",
    logs: "/logs",
    logsAbsolute: "/profile/logs",
  },
};
